import { Box, Button, CircularProgress, FormControl, Grid, IconButton, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { useSnackbar } from "notistack";

import { Link, useNavigate, useParams } from "react-router-dom";


import { useEffect, useRef, useState } from "react";

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { format } from 'date-fns';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import { DocumentoDarCienciaList } from "../../../types/documento/darCiencia/DocumentoDarCienciaList";
import { useGetDocumentoCienciasQuery } from "./DocumentoDarCienciaApiSlice";
import { DocumentoInternoViewMenu } from "../documentoView/DocumentoInternoViewMenu";


export const DocumentoDarCienciaListForm = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // Hook para navegação

    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum documento selecionado");
            window.location.href = configUrls.PROCESSO_LIST_RT
        }
    }, [processoSelecionado]);



    /*SEARCH*/

    const [search, setSearch] = useState<string>("");
    const [debouncedSearch, setDebouncedSearch] = useState<string>("");
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const cursorPosition = useRef<number>(0);

    const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        cursorPosition.current = inputRef.current?.selectionStart || 0;
        setSearch(e.target.value);
    };

    useEffect(() => {
        // Limpar o timeout anterior
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        // Configurar o timeout para o debounce
        debounceTimeout.current = setTimeout(() => {
          
            setDebouncedSearch(search);
        }, 700); // Tempo de debounce (700ms)

        // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, [search]);

    // FIM DO SEARCH






    const [ciencias, setCiencias] = useState<DocumentoDarCienciaList[]>([]);
    const id = useParams().id || "";

    const { data, isFetching, error } = useGetDocumentoCienciasQuery({ id: id ?? "", search: debouncedSearch });
    useEffect(() => {
        if (data) {
            setCiencias(data);
        }
        if (error) {
            enqueueSnackbar("Ciências não encontradas!", { variant: "error" });
        } else if (isFetching) {
            enqueueSnackbar("Buscando registros...", { variant: "info" });
        }

        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current?.setSelectionRange(cursorPosition.current, cursorPosition.current);
        }

    }, [data, error, isFetching, enqueueSnackbar]);









    if (isFetching) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    const headerGerados = (
        <Typography variant="body2" color="textSecondary">
            Ciência(s) encontrada(s): {ciencias.length}
        </Typography>
    );


    const renderData = (rowData: DocumentoDarCienciaList) => {
        const dataCriacao = rowData.dataHora ? format(rowData.dataHora, 'dd/MM/yyyy HH:mm:ss') : "Data não disponível";
        return <Typography color="secondary" variant="body2">{dataCriacao}</Typography>;
    };

    const renderUsuario = (rowData: DocumentoDarCienciaList) => (
        <Typography color="secondary" variant="body2">{rowData.usuario?.nome || "Usuário não disponível"}</Typography>
    );

    return (
        <>
            <Box sx={{ padding: 2 }}>



                <Paper sx={{ width: "100%", height: "100vh", padding: "12px" }}>
                    <Grid container padding={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>


                                <Box display="flex" justifyContent="space-between" mb={2}>

                                    <Box display="flex">
                                        <Typography color="secondary" variant="h6" gutterBottom>
                                            Ciências para o documento: {processoSelecionado?.numeroProcesso}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="flex-end">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => navigate(-1)}
                                        >
                                            Voltar
                                        </Button>
                                    </Box>
                                </Box>




                            </FormControl>
                        </Grid>

                        <Grid item xs={12} mt={5} >
                            <FormControl fullWidth>
                                <TextField
                                    label="Digite para pesquisar"
                                    name="nome"
                                    onChange={handleChangeSearch}
                                    size="small"
                                    inputProps={{ maxLength: 100 }}
                                    value={search}
                                    inputRef={inputRef}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <DataTable
                        value={ciencias}
                        paginator
                        rows={25}
                        showGridlines={true}
                        size="small"
                        columnResizeMode="expand"
                        resizableColumns
                        dataKey="id"
                        header={headerGerados}
                        className="custom-datatable"
                    >

                        <Column header="Data" body={renderData} sortable style={{ width: '30%' }} />
                        <Column header="Usuário" body={renderUsuario} sortable style={{ width: '70%' }} />


                    </DataTable>


                </Paper>

            </Box>








        </>







    );










};
